import { render, staticRenderFns } from "./lazyblock_what_to_do.vue?vue&type=template&id=20ba54e7&scoped=true"
import script from "./lazyblock_what_to_do.vue?vue&type=script&lang=js"
export * from "./lazyblock_what_to_do.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_what_to_do.vue?vue&type=style&index=0&id=20ba54e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba54e7",
  null
  
)

export default component.exports